import styled from 'styled-components'

import { Title as SharedTitle } from 'components/Catalog/catalog.styles'

export const TemplatesWrapper = styled.div`
    display: flex;
    position: relative;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 48px;
    width: 100%;
`

export const Title = styled(SharedTitle)`
    cursor: default;
`

export { Header, Navigation, List } from 'components/Catalog/catalog.styles'
